// extracted by mini-css-extract-plugin
export default {"mybtn":"style_mybtn__cryoX"};